import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flow-root" }
const _hoisted_2 = {
  role: "list",
  class: "-mb-8"
}
const _hoisted_3 = { class: "relative pb-8" }
const _hoisted_4 = {
  key: 0,
  class: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-secondary-bg dark:bg-secondary-dark-bg",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "relative flex space-x-3" }
const _hoisted_6 = { class: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" }
const _hoisted_7 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-secondary-text/70 dark:text-secondary-dark-text/70 mt-1"
}
const _hoisted_9 = { class: "text-right text-sm whitespace-nowrap text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_10 = ["datetime"]
const _hoisted_11 = {
  key: 0,
  class: "text-center py-8 text-secondary-text dark:text-secondary-dark-text"
}

import { h } from 'vue'

interface Activity {
  type: 'exam' | 'certificate' | 'material' | 'profile' | 'form'
  description: string
  details?: string
  time: string
  datetime: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityTimeline',
  props: {
    activities: {}
  },
  setup(__props: any) {



const activityIcon = (type: string) => {
  const iconPath = (d: string) => h('svg', {
    class: 'h-5 w-5',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 20 20',
    fill: 'currentColor'
  }, [
    h('path', { 'fill-rule': 'evenodd', d, 'clip-rule': 'evenodd' })
  ])

  switch (type) {
    case 'exam':
      return iconPath('M9 2a1 1 0 000 2h2a1 1 0 100-2H9z M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z')
    case 'certificate':
      return iconPath('M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z')
    case 'material':
      return iconPath('M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z')
    case 'form':
      return iconPath('M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 2a1 1 0 011-1h1a1 1 0 110 2H7a1 1 0 01-1-1zm3 3a1 1 0 100 2h.01a1 1 0 100-2H9zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H9zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z')
    default:
      return iconPath('M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z')
  }
}

const activityIconBg = (type: string): string => {
  switch (type) {
    case 'exam':
      return 'bg-primary dark:bg-primary-dark'
    case 'certificate':
      return 'bg-success dark:bg-success-dark'
    case 'material':
      return 'bg-info dark:bg-info-dark'
    case 'form':
      return 'bg-success dark:bg-success-dark'
    default:
      return 'bg-secondary dark:bg-secondary-dark'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activities, (activity, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "transform transition-all duration-300 hover:-translate-x-1"
        }, [
          _createElementVNode("div", _hoisted_3, [
            (index !== __props.activities.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white dark:ring-gray-800 shadow-lg", activityIconBg(activity.type)])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(activityIcon(activity.type)), { class: "h-5 w-5 text-white" }))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(activity.description), 1),
                  (activity.details)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(activity.details), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("time", {
                    datetime: activity.datetime
                  }, _toDisplayString(activity.time), 9, _hoisted_10)
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    (__props.activities.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "No recent activity", -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}
}

})